import { render, staticRenderFns } from "./Dismissed.vue?vue&type=template&id=682b2e81&"
import script from "./Dismissed.vue?vue&type=script&lang=ts&"
export * from "./Dismissed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports